<template>
  <div class="center">
    <div v-if="userLoggedIn && loading">
      <div class="bb-ff2 bb-fs1pt2 bb-fc1 mt4">{{ $lang.messages.loading }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.loading_submsg1 }}</div>
      <div class="mt4">
        <img class="bb-w5 bb-h5"
          src="../assets/images/loader.svg"></img>
      </div>
    </div>
    <div v-if="paymentError">
      <div class="bb-ff2 bb-fs1pt2 bb-fc5 mt4">{{ $lang.messages.sorry }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.conf_err_submsg1 }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.conf_err_submsg2 }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc1 mt2">or</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.conf_err_submsg3 }}</div>
      <div class="bb-mt2pt56 mx-auto bb-w12">
        <router-link to="/" class="text-decoration-none border-none">
          <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
          bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0
          bb-transition2">
          {{ $lang.messages.done }}
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="voucherPayment || gatewayPaymentSuccess">
      <div class="bb-ff2 bb-fs1pt2 bb-fc1 mt4">{{ $lang.messages.thank_you }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.success_submsg1 }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc1 mt1">{{ selectedOptions.experienceName }} experience, {{
        selectedOptions.timestamp }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt2">{{ $lang.messages.success_submsg2 }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc1 mt1">{{ userInfo.email }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc3 mt1">{{ $lang.messages.success_submsg3 }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc1 mt1"
        v-if="gatewayPaymentSuccess">{{ bookingActivity[0].id | referenceId }}</div>
      <div class="bb-ff2 bb-fs1 bb-fc1 mt1"
        v-if="voucherPayment">{{ voucherFeedback.id | referenceId }}</div>
      <div class="bb-mt2pt56 mx-auto bb-w12">
        <router-link to="/" class="text-decoration-none border-none">
          <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
          bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0
          bb-transition2">
          {{ $lang.messages.done }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data () {
    return {
      paymentError: false,
      loading: true,
      voucherPayment: false,
      gatewayPaymentSuccess: false,
      paymentStatusRetry: {
        limit: 20,
        count: 0
      }
    }
  },
  computed: {
    voucherFeedback () {
      return this.$store.getters.getVoucherActivity
    },
    selectedOptions () {
      return this.$store.getters.getSelectedOptions
    },
    voucherError () {
      return this.$store.getters.getVoucherError
    },
    userInfo () {
      return this.$store.getters.getUserInfo
    },
    bookingActivity () {
      return this.$store.getters.getBookingActivity
    }
  },
  filters: {
    referenceId: function (id) {
      return id.substring(id.length - 8, id.length)
    }
  },
  watch: {
    voucherError: function () {
      this.loading = false
      this.paymentError = true
    },
    userInfo () {
      this.getBookingActivity()
    },
    bookingActivity: function () {
      //check if booked successfully
      if (this.bookingActivity && this.bookingActivity[0] && this.bookingActivity[0].doc
        && this.bookingActivity[0].doc.booking && this.bookingActivity[0].doc.booking.confirmed) {
        this.gatewayPaymentSuccess = true
        this.loading = false
      } else {
        //if not booked successfully then retry until retry limit reached
        if (this.paymentStatusRetry.count < this.paymentStatusRetry.limit - 1) {
          if (this.userLoggedIn) {
            // increase the count only if user is logged in and we are currently
            // waiting for confirmation, otherwise keep on retrying until user
            // is actually logged in.
            this.paymentStatusRetry.count = this.paymentStatusRetry.count + 1
          }
          setTimeout(() => {
            this.getBookingActivity()
          }, 3000);
        } else {
          // if retry limit reached, show error message
          this.loading = false
          this.paymentError = true
        }
      }
    }
  },
  methods: {
    getBookingActivity: function () {
      this.$store.dispatch('LOAD_BOOKING_ACTIVITY', {
        id: this.$route.params.activity_id,
        token: this.$localStorage.get('token')
      })
    }
  },
  created () {
    if (this.userLoggedIn) {
      if (this.voucherFeedback) {
        this.voucherPayment = true
        this.loading = false
      } else {
        this.getBookingActivity()
      }
    } else {
      this.forceLogin()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/confirmation.vue